import React from 'react';
import PropTypes from 'prop-types';
import InfoTip from '../../atoms/InfoTip';
import { cn } from '../../cn';

const MetricCard = ({
  label,
  value,
  sub,
  hint,
  accent,
  tooltip,
  className = ''
}) => {
  const subtitle = sub ?? hint;

  return (
    <div className={cn('bg-white p-5 rounded-xl border border-gray-100 relative', className)}>
      <div className="flex items-center gap-1.5 mb-1">
        <div className="text-[13px] text-gray-500 font-sans">{label}</div>
        {tooltip && <InfoTip text={tooltip} className="ml-0" />}
      </div>
      <div className={cn('text-2xl font-semibold tracking-tight font-sans', accent || 'text-gray-900')}>
        {value}
      </div>
      {subtitle && <div className="text-xs text-gray-400 mt-1.5">{subtitle}</div>}
    </div>
  );
};

MetricCard.displayName = 'MetricCard';

MetricCard.propTypes = {
  label: PropTypes.node.isRequired,
  value: PropTypes.node.isRequired,
  sub: PropTypes.node,
  hint: PropTypes.node,
  accent: PropTypes.string,
  tooltip: PropTypes.string,
  className: PropTypes.string
};

export default MetricCard;
